export default "__VITE_ASSET__6dc15930__"